import { OwnerOptions } from '../../api/useInsuranceQuery';

export const getIsOwnerTrust = (owner: string, ownerOptions: OwnerOptions) => {
  const trustOptions = ownerOptions.Trusts;

  return !!trustOptions?.includes(owner);
};
